var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logoContainer"},[_c('BaseImage',{attrs:{"source":_vm.logo,"model":"","alt":`${_vm.title} ${_vm.$t('logo')}`,"size":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }